import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "../../ui";
import { defaultProduct, useAdminWorkspace } from "./useAdminWorkspace";

/** `/admin` and the old flat `/admin/<section>` paths: send them into a product workspace. */
export function AdminEntry({ section }: { section?: string }) {
  const workspace = useAdminWorkspace();
  const location = useLocation();

  if (workspace.isLoading) {
    return (
      <main className="p-8">
        <Spinner />
      </main>
    );
  }
  if (!workspace.isStaff) return <Navigate to="/account" replace />;

  const product = defaultProduct(workspace.products);
  if (!product) return <Navigate to="/admin/platform" replace />;
  const suffix = section ? `/${section}` : "";
  return (
    <Navigate
      to={`/admin/p/${product.slug}${suffix}${location.search}`}
      replace
    />
  );
}
